import styled from "styled-components/macro"

export const SeasonEndTime = styled.h2`
  font-size: ${props => props.theme.fontSize.header};
  padding-bottom: 4px;
  border-bottom: 1px solid #cccccc55;
`

export const NextSeason = styled.div`
  margin-bottom: ${props => props.theme.bottom};
`